import { combineReducers } from 'redux';
import { createScopedReducer } from '@mews-commander/utils';
import {
    ENTITY_ADDING_STARTED,
    ENTITY_ADDING_STOPPED,
    ENTITY_EDITING_STARTED,
    ENTITY_EDITING_STOPPED,
    ENTITY_DELETING_STARTED,
    ENTITY_DELETING_STOPPED,
    ADD_ENTITY_STARTED,
    ADD_ENTITY_SUCCEEDED,
    ADD_ENTITY_FAILED,
    EDIT_ENTITY_STARTED,
    EDIT_ENTITY_SUCCEEDED,
    EDIT_ENTITY_FAILED,
    DELETE_ENTITY_STARTED,
    DELETE_ENTITY_SUCCEEDED,
    DELETE_ENTITY_FAILED,
} from './actions';

const meta = createScopedReducer(
    {},
    {
        [ENTITY_ADDING_STARTED]: (state: $TSFixMe) => ({
            ...state,
            isAdding: true,
        }),

        [ENTITY_ADDING_STOPPED]: (state: $TSFixMe) => ({
            ...state,
            isAdding: false,
        }),

        // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
        [ENTITY_EDITING_STARTED]: (state, selectedEntityId) => ({
            ...state,
            selectedEntityId,
            isEditing: true,
        }),

        [ENTITY_EDITING_STOPPED]: (state: $TSFixMe) => ({
            ...state,
            selectedEntityId: null,
            isEditing: false,
        }),

        // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
        [ENTITY_DELETING_STARTED]: (state, selectedEntityId) => ({
            ...state,
            selectedEntityId,
            isDeleting: true,
        }),

        [ENTITY_DELETING_STOPPED]: (state: $TSFixMe) => ({
            ...state,
            isDeleting: false,
        }),

        [DELETE_ENTITY_SUCCEEDED]: (state: $TSFixMe) => ({
            ...state,
            isEditing: false,
        }),
    }
);

const started = () => ({ isFetching: true, hasSucceeded: false, hasFailed: false });
const succeded = () => ({ isFetching: false, hasSucceeded: true, hasFailed: false });
const failed = () => ({ isFetching: false, hasSucceeded: false, hasFailed: true });

const asyncState = createScopedReducer(
    {},
    {
        [ADD_ENTITY_STARTED]: started,
        [ADD_ENTITY_SUCCEEDED]: succeded,
        [ADD_ENTITY_FAILED]: failed,

        [EDIT_ENTITY_STARTED]: started,
        [EDIT_ENTITY_SUCCEEDED]: succeded,
        [EDIT_ENTITY_FAILED]: failed,

        [DELETE_ENTITY_STARTED]: started,
        [DELETE_ENTITY_SUCCEEDED]: succeded,
        [DELETE_ENTITY_FAILED]: failed,
    }
);

export default combineReducers({
    meta,
    asyncState,
});
